import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

export function unwrap<T>(x: T | null): T {
  if (x == null) {
    throw new Error("unexpected null");
  }
  return x;
}

export const worker = new Worker(new URL("Worker.tsx", import.meta.url));
const dialog = unwrap(document.querySelector("dialog"));
const showButton = unwrap(document.querySelector("#showHelp"));
showButton.addEventListener("click", () => {
  dialog.showModal();
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
